export default function SVGStove(props: any) {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_1216_19267)">
                <rect x="12" y="6" width="40" height="52" rx="2" stroke="#757575" strokeWidth="2" />
                <path
                    d="M32 39C38.0751 39 43 34.0751 43 28C43 21.9249 38.0751 17 32 17C25.9249 17 21 21.9249 21 28C21 34.0751 25.9249 39 32 39Z"
                    stroke="#757575"
                    strokeWidth="1.77778"
                />
                <path
                    d="M32 34C35.3137 34 38 31.3137 38 28C38 24.6863 35.3137 22 32 22C28.6863 22 26 24.6863 26 28C26 31.3137 28.6863 34 32 34Z"
                    stroke="#757575"
                    strokeWidth="1.77778"
                />
                <path d="M12 48L51 48" stroke="#757575" strokeWidth="1.77778" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M21 53H17" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M29 53H25" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M37 53H33" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_1216_19267">
                    <rect width="64" height="64" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
